module.exports = __webpack_public_path__ + "img/canada.1ba6eb3d.svg";